/* Amy Lucy v1.6: save free gift messages before basket checkout.
   The base theme saves hdt-cart-note on change, but checkout navigation can
   otherwise outrun an in-flight note update after a customer types a message.
   This only intervenes when the note value has changed. */
(() => {
  if (window.__amyLucyGiftNoteCheckoutGuard) return;
  window.__amyLucyGiftNoteCheckoutGuard = true;

  const readyToProceed = new WeakSet();
  const saving = new WeakSet();

  const getMessageField = (form) => {
    if (form.id === 'CartPage-Form') {
      return document.querySelector('#hdt-page-cart hdt-cart-note textarea[name="note"]');
    }
    if (form.id === 'CartDrawer-Form') {
      return document.querySelector('#CartDrawer hdt-cart-note textarea[name="note"]');
    }
    return null;
  };

  const announce = (note, message, isError) => {
    let status = note.parentElement?.querySelector('[data-al-gift-note-status]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-al-gift-note-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.style.cssText = 'font:600 12px/1.4 Lato,Arial,sans-serif;margin:7px 0;color:#4A0828';
      note.insertAdjacentElement('afterend', status);
    }
    status.textContent = message;
    status.style.color = isError ? '#A30D3C' : '#4A0828';
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    const submitter = event.submitter;

    if (!(form instanceof HTMLFormElement) || !submitter || submitter.name !== 'checkout') return;
    if (form.id !== 'CartPage-Form' && form.id !== 'CartDrawer-Form') return;

    if (readyToProceed.has(form)) {
      readyToProceed.delete(form);
      return;
    }

    const note = getMessageField(form);
    if (!note || note.value === note.defaultValue) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (saving.has(form)) return;
    saving.add(form);
    const giftMessage = note.value;
    announce(note, 'Saving your gift message…', false);
    submitter.disabled = true;

    const root = window.Shopify?.routes?.root || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      credentials: 'same-origin',
      body: JSON.stringify({note: giftMessage})
    })
      .then((response) => {
        if (!response.ok) throw new Error('Gift note could not be saved');
        return response.json();
      })
      .then((cart) => {
        if (cart.note !== giftMessage) throw new Error('Gift note not confirmed');
        note.defaultValue = giftMessage;
        announce(note, 'Gift message saved.', false);
        if (form.isConnected && submitter.isConnected) {
          readyToProceed.add(form);
          submitter.disabled = false;
          form.requestSubmit(submitter);
        }
      })
      .catch(() => {
        announce(note, 'We could not save your gift message. Please try again before checkout.', true);
        submitter.disabled = false;
        note.focus();
      })
      .finally(() => {
        saving.delete(form);
        submitter.disabled = false;
      });
  }, true);
})();